export default __webpack_public_path__ + "static/media/lora.47bdc98a.jpg";